import { createAsyncThunk } from '@reduxjs/toolkit';

import { GetInvitationProps } from 'entities/Invitation';
import { getInvitationService } from 'services/invitation.service';

export const getInvitation = createAsyncThunk(
  'invitation/getInvitation',
  async (data: GetInvitationProps, thunkApi) => {
    try {
      const response = await getInvitationService(data);

      return response.data.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
